var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterVisitorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 90,
    viewBox: "0 0 90 90",
    width: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    fill: "#9cdbd9",
    r: 45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.73 5.045c-1.574 2.641-.866 7.128 1.942 12.307a5.65 5.65 0 0 1 .461 5.2c-1.339 2.97-5.011 3.817-8.9 4.713-2.678.619-2.508 1.186-2.508 5.46h-2.718l-.007-1.69c0-3.436.271-5.42 4.334-6.359 4.589-1.06 9.12-2.009 6.941-6.025-6.455-11.902-1.841-18.651 5.089-18.651 4.528 0 8.136 2.887 8.136 8.41 0 4.848-2.658 9.318-3.25 10.681h-2.879c.534-2.091 3.408-5.954 3.408-10.691 0-7.027-8-6.8-10.049-3.352zm18.27 20.864h-4.091v-4.091h-2.727v4.091h-4.091v2.727h4.091v4.091h2.727v-4.091h4.091z",
    fill: "#fff",
    transform: "translate(29 29)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterVisitorIcon);
export default __webpack_public_path__ + "static/media/register-visitor-icon.f1b88b0f.svg";
export { ForwardRef as ReactComponent };